import { Stack } from "@mui/material";

import { type WorkerRateNegotiationResponse } from "./api/useWorkerNegotiationShifts";
import { RateNegotiationListItem } from "./RateNegotiationListItem";

interface RateNegotiationListContentProps {
  workerNegotiationShifts: WorkerRateNegotiationResponse;
}

export function RateNegotiationListContent(props: RateNegotiationListContentProps) {
  const { workerNegotiationShifts } = props;

  return (
    <Stack sx={{ marginX: 5 }}>
      {workerNegotiationShifts.map((workerNegotiationShift) => (
        <RateNegotiationListItem
          key={workerNegotiationShift._id}
          workerNegotiationShift={workerNegotiationShift}
        />
      ))}
    </Stack>
  );
}
